import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login/Login.vue'
import Main from '@/views/Main/Main.vue'
import Welcome from '@/views/Welcome/Welcome.vue'
import Users from '@/views/Users/Users.vue'
import user from '@/views/Users/user.vue'
import Cate from '@/views/Cate/index.vue'
import Qiche from '@/views/Qiche/index.vue'
import Dingdan from '@/views/Dingdan/index.vue'
import Youji from '@/views/Youji/index.vue'
import Xitong from '@/views/Xitong/index.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    redirect: "/login"
  },
  {
    path: "/login",
    component: Login
  },
  {
    path: "/main",
    component: Main,
    redirect:"/welcome",
    children:[
      {
        path:'/welcome',
        component:Welcome,
      },
      {
        path:'/users',
        component:Users,
      },
	  {
	    path:'/user',
	    component:user,
	  },
	  {
	    path:'/cate',
	    component:Cate,
	  },
	  {
	    path:'/qiche',
	    component:Qiche,
	  },
	  {
	    path:'/dingdan',
	    component:Dingdan,
	  },
	  {
	    path:'/youji',
	    component:Youji,
	  },
	  {
	    path:'/xitong',
	    component:Xitong,
	  }
    ]
  },
]

const router = new VueRouter({
  routes
})

export default router
